import React from "react";

export default function Whatis() {
  return (
    <section className="relative w-full overflow-hidden bg-white text-gray-900">
      <div className="mx-auto max-w-6xl py-12 px-4 sm:px-4"> 
        <div className="flex flex-col items-center">
          <p 
            className="
              text-center max-w-6xl px-8 
              font-uber text-base font-normal leading-normal text-black
            "
          >
            With digital attention spans shrinking, brands needed a solution that could captivate users instantly. Playable Ads emerged as an innovative format, turning passive viewing into active engagement.
          </p>
        </div>
        <div className="border-b border-black pb-8 mb-8 w-full"></div> 
        <div className="flex flex-col xl-custom:flex-row gap-12 pt-10">
          <div className="w-full xl-custom:w-1/2 flex justify-center order-1 xl-custom:order-2">
            <img
              src="/uploads/CaseStudy/whatisplayable.webp"
              alt="Playable Ad Example"
              className="w-full max-w-lg h-auto object-cover rounded-xl"
            />
          </div>
          <div className="w-full xl-custom:w-1/2 text-center xl-custom:text-left order-2 xl-custom:order-1 mb-8 xl-custom:mb-0">
            <h1 
              className="
                mb-8 w-full
                font-uber text-[28px] font-bold leading-[36px] text-current
                sm:text-[32px] sm:leading-[40px]
                xl-custom:text-[36px] xl-custom:leading-[44px]
                transition duration-200 ease-in-out
              "
            >
              What is Playable?
            </h1>
            <p 
              className="
                mb-8 text-black 
                font-uber text-base font-normal leading-normal
              "
            >
              A playable is an interactive experience that allows users to engage with content in a game-like manner. Unlike traditional static ads, playables offer hands-on interaction, making them more engaging and memorable.
            </p>
            <p 
              className="
                text-black 
                font-uber text-base font-normal leading-normal
              "
            >
              By leveraging data insights and customer behavior patterns, it helps enhance user retention, drive conversions, and create a lasting impact on brand perception.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}